import { Outlet } from "react-router-dom";
import SiteHeader from "@/components/layout/SiteHeader";
import SiteFooter from "@/components/layout/SiteFooter";

export default function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 w-full">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}